// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8465":"4741fc6c6e76c771","8777":"fb973a72f67fe90d"}[chunkId] + ".js";
};